module.exports = __webpack_public_path__ + "img/logo.15d928d6.png";